import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ViewprogressContainerComponent } from "./container/viewprogress-container/viewprogress-container.component";

const routes: Routes = [
    
    {path: 'adrprogress', component: ViewprogressContainerComponent},
  ];
  
  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class AdrProgressRoutingModule {}